import { Layout } from 'components/Layout'
import { ArcPageShell } from 'components/ArcPageShell'
import { CurrentUserContextProvider } from 'context/useCurrentUser'
import { NotificationProvider } from 'context'
import { useTranslation } from 'react-i18next'
import { SettingsGrid } from './components/SettingsGrid'

function SchoolSettingsView() {
  const { t } = useTranslation()

  return (
    <Layout>
      <ArcPageShell title={t('school_settings.title')} subtitle={t('school_settings.subtitle')}>
        <SettingsGrid />
      </ArcPageShell>
    </Layout>
  )
}

export function SchoolSettingsPage() {
  return (
    <CurrentUserContextProvider>
      <NotificationProvider>
        <SchoolSettingsView />
      </NotificationProvider>
    </CurrentUserContextProvider>
  )
}
